var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('page-bar',{ref:"pageBar",attrs:{"active-color":"#209CFF","bg-color":_vm.barConf.bgColor,"blank-show":_vm.barConf.blankShow,"login-color":"#209CFF"}}),_c('router-view',{ref:"routeview"}),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }